import React from 'react';
import { Stack, Button, Typography, Box, Badge } from '@mui/material';
import { Add as AddIcon, ImportExport, Tune } from '@mui/icons-material';

const ActionButtons = ({ role=null, showAddModal=null, showModal=null,
     is_all_vehicles=true }) => {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      mb: 3,
      p: 2,
      backgroundColor: 'background.paper',
      borderRadius: 2,
      boxShadow: 1
    }}>
      <Typography variant="h5" sx={{ 
        fontWeight: 600,
        color: 'text.primary',
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        <Box component="span" sx={{ 
          width: 4,
          height: 24,
          backgroundColor: 'primary.main',
          borderRadius: '2px',
          display: 'block'
        }} />
        {is_all_vehicles ? 'All': "Active"} Vehicles
      </Typography>
       {is_all_vehicles && (
            <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
             {role.filter(function (e) {
                    return e.perm_name === "add_vehicle";
                  }).length > 0 && (
            <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={showAddModal}
                sx={{
                borderRadius: '8px',
                px: 3,
                py: 1,
                textTransform: 'none',
                boxShadow: 'none',
                '&:hover': { boxShadow: 1 }
                }}
            >
                Add Vehicle
            </Button>
            )}

            {/* <Button
            variant="outlined"
            color="secondary"
            startIcon={<ImportExport />}
            onClick={showModal}
            sx={{
                borderRadius: '8px',
                px: 3,
                py: 1,
                textTransform: 'none',
                borderWidth: 2,
                '&:hover': { borderWidth: 2 }
            }}
            >
            Export
            </Button> */}
            </Stack>
       )}  
     
    </Box>
  );
};

export default ActionButtons;